import axios from "@/plugins/axios.js";

export default {
  async getImagesForGivenFolder(folder) {
    const images = await axios.postDataWithToken(
      "/auth/get-images-for-given-folder",
      { folder },
      localStorage.getItem("token")
    );
    return images;
  },
  async deleteImage(imageFolderPathWithinPublic, imageName) {
    const images = await axios.postDataWithToken(
      "/auth/delete-image",
      { image: imageName, folder: imageFolderPathWithinPublic },
      localStorage.getItem("token")
    );
    return images;
  },
  getImagesPublicFullPath(imageFolderPathWithinPublic, imagesNames) {
    let imagesWithPath = [];
    if (imagesNames.length > 0) {
      for (let i = 0; i < imagesNames.length; i++) {
        imagesWithPath.push(
          "https://myofficeonlineapi.bitsems.co.za/" +
            imageFolderPathWithinPublic +
            "/" +
            imagesNames[i]
        );
      }
    } else {
      imagesWithPath = ["/images/products/no-photo.jpg"];
    }
    return imagesWithPath;
  },
  getBase64ImageFromURL(url) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.setAttribute("crossOrigin", "anonymous");

      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

        const dataURL = canvas.toDataURL("image/png");

        resolve(dataURL);
      };

      img.onerror = (error) => {
        reject(error);
      };

      img.src = url;
    });
  },
  async getWebsiteBanner(domain) {
    const websiteBanners = await axios.postData("/get-company-website-banner", {
      domain,
    });
    if (websiteBanners && websiteBanners.length > 0) {
      return websiteBanners[0];
    } else {
      return null;
    }
  },
};
